import type { VideoUploadEntry } from '../../../contexts/VideoUploadContext';

export interface AthleteGroup {
  athleteId: string;
  athleteName: string;
  uploading: number;
  failed: number;
}

export function groupByAthlete(entries: VideoUploadEntry[]): AthleteGroup[] {
  const map = new Map<string, AthleteGroup>();
  for (const e of entries) {
    if (e.status !== 'uploading' && e.status !== 'error') continue;
    const existing = map.get(e.athleteId) ?? {
      athleteId: e.athleteId,
      athleteName: e.athleteName,
      uploading: 0,
      failed: 0,
    };
    if (e.status === 'uploading') existing.uploading += 1;
    if (e.status === 'error') existing.failed += 1;
    map.set(e.athleteId, existing);
  }
  return Array.from(map.values());
}
